/**
 * Get current viewer country code
 * @param  {Object} countryGroups    List of country groups containing arrays of country codes
 * @return {String}                 The viewer's country group
 */

import { getCountryCode } from './country-code'

export async function getCountryGroup(countryGroups) {
  if (!countryGroups || countryGroups === null) {
    return ''
  }

  let viewerCountryHeader = getCountryCode()

  // Find and return the current user's country group
  return (
    new Promise((resolve) => {
      let currentGroupCode = 'esrb'
      countryGroups.map((group, i) => {
        let groupCode = group.groupCode
        let countryList = group.countryList
        if (countryList.split(',').indexOf(viewerCountryHeader) > -1) {
          currentGroupCode = groupCode
        }
      })
      resolve(currentGroupCode)
    }).then(function (currentGroupCode) {
      let data = {countryCode: viewerCountryHeader, groupCode: currentGroupCode}
      return data
    })
  )
}
